import createDataContext from './createDataContext';
import * as myProfileActions from './actions/myProfileActions';
import { myProfileReducer, initialState } from './reducers/myProfileReducer';

export const { Context: MyProfileContext, Provider } = createDataContext(
  myProfileReducer,
  myProfileActions,
  initialState
);
